'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024 from "./presto.types$-Account-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$18() {
  this.bfl = null;
  this.bfj = null;
  this.bfk = false;
  this.bfh = null;
  this.bfi = false;
  this.bfm = false;
  this.bfn = false;
  this.bfl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$18 as $c_Lpresto_PrestoRouter$$anon$18 };
$p = $c_Lpresto_PrestoRouter$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$18;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$18() {
}
export { $h_Lpresto_PrestoRouter$$anon$18 as $h_Lpresto_PrestoRouter$$anon$18 };
$h_Lpresto_PrestoRouter$$anon$18.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bfl;
});
$p.t = (function() {
  if ((!this.bfk)) {
    this.bfj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bfk = true;
  }
  return this.bfj;
});
$p.ae = (function() {
  if ((!this.bfi)) {
    this.bfh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().a2E(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dName$0024.$m_Lpresto_types$AccountName$().cs3(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bfi = true;
  }
  return this.bfh;
});
$p.w = (function() {
  if ((!this.bfn)) {
    this.bfm = false;
    this.bfn = true;
  }
  return this.bfm;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$18, "presto.PrestoRouter$$anon$18", ({
  NI: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$18 as $d_Lpresto_PrestoRouter$$anon$18 };
//# sourceMappingURL=presto.-Presto-Router$$anon$18.js.map
